import { TranslateExtent, useStoreState, Node } from 'react-flow-renderer';
import { useMemo } from 'react';

export const DEFAULT_BOTTOM_Y_COMPENSATION = 300;

export const useTranslateExtent = ({
  bottomYCompensation,
}): TranslateExtent => {
  const nodes = useStoreState(state => state.nodes);
  const rootNode = nodes[0] as Node & { width?: number };

  const totalWidth = useStoreState(store => store.width);

  const [maxX, maxY] = useMemo(() => {
    return nodes.reduce(
      (a, n) => {
        n.position.x > a[0] ? (a[0] = n.position.x) : '';
        n.position.y > a[1] ? (a[1] = n.position.y) : '';
        return a;
      },
      [0, 0],
    );
  }, [nodes]);

  const {
    width,
    position: { x },
  } = rootNode || { width: 0, position: { x: 0 } };

  const compensateX = totalWidth - (width || 0) / 2 - x;

  const topX = compensateX * -1;
  const bottomX = maxX + compensateX;
  const bottomY = maxY + bottomYCompensation;

  return useMemo(() => {
    return [
      [topX, 0],
      [bottomX, bottomY],
    ];
  }, [topX, bottomY, bottomX]);
};
